export var ACTION_TYPE_PREFIX = '@@RECOMMENDED_TORPEDO';
export var RECOMMENDED_TORPEDO_STREAM_ID = 'RECOMMENDED_TORPEDO_STREAM';
export var DEVIATIONS_PER_FETCH_COUNT = 24;
export var BROWSE_RFY_ENDPOINT = '/deviation/recommended';
//# sourceMappingURL=constants.js.map